export default class Sidebar {
    mount({ sidebarSelector, mainSelector, navbarComponentRoot, cookieBannerWrapper }) {
        const $sidebar = $(sidebarSelector);
        const $navbarComponentRoot = $(navbarComponentRoot);
        const $cookieBannerWrapper = $(cookieBannerWrapper);
        const activeSidebarLink = $sidebar.find(".active").last();

        const cookieBannerHeight = $cookieBannerWrapper.outerHeight() || 0;

        // back button that only appears on mobile
        $(`${sidebarSelector} .back-btn`).click(() => {
            $(sidebarSelector).hide();
            $(mainSelector).show();
        });

        // Don't scroll the sidebar if there's nowhere to scroll it to.
        // This happens on the home page and orphan pages
        if (activeSidebarLink.length < 1) {
            return;
        }

        const activeSidebarLinkY =
            activeSidebarLink.offset().top - $sidebar.offset().top;
        const oneThirdSidebarHeight = $sidebar.height() / 3;

        $sidebar.scrollTop(activeSidebarLinkY - oneThirdSidebarHeight);

        // Close all sibling sections and their children sections when a section
        // is clicked.
        $sidebar.find(".checkbox").each((i, el) => {
            $(el).click(e => {
                const $otherCheckboxes = $(el)
                    .closest(".section")
                    .siblings(".section")
                    .find(".checkbox");
                $otherCheckboxes.prop("checked", false);
            });
        });

        const currPaddingTop = $sidebar.css("padding-top");
        $sidebar.css("padding-top", currPaddingTop + $navbarComponentRoot.outerHeight() + cookieBannerHeight);
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/sidebar.js